export enum TestType {
  BasicReading = 'basic-reading'
}

export type OverallTestStatus = 'not-started' | 'in-progress' | 'pass' | 'fail';

export const TEST_STATUS = {
  NOT_STARTED: 'not-started',
  IN_PROGRESS: 'in-progress',
  PASS: 'pass',
  FAIL: 'fail'
} as const;

export const SHOW_FILTER = {
  AS_FOUND: 'asFound',
  ALL: 'all',
  AS_LEFT: 'asLeft'
} as const;
